import axios from "axios";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { auto_complete_map as auto_complete_map_helper } from "@/components/Delivery/delivery_helpers";
import {
    add_to_cart as add_to_cart_helper
} from "@/components/cart/cart_helper";
import { get_token,get_user_details } from "@/router";
import { get_active_organization_id, is_enabled_feature } from "@/utils/organization_profile";
import {
    reset_service_request_state,view_profile_product,
    submit_service_request_flow,go_to_profile,
    get_service_request_prefill,
    sanitize_service_request_phone_number,
    normalize_service_request_date,
    build_service_availability_days,
    get_service_availability_month_label,
    get_service_availability_times,
    format_service_slot_label,
    build_service_request_datetime,
    is_service_request_slot_disabled,
    display_marketplace_price,
    format_price as format_marketplace_price,
    has_active_marketplace_product_sale,
    get_marketplace_original_price,
    get_marketplace_sale_price,
    get_marketplace_sale_discount_label,
    get_marketplace_company_name,
    group_marketplace_attributes,
    get_required_marketplace_attribute_groups,
    select_marketplace_attribute,
    validate_marketplace_required_attributes,
    get_marketplace_product_base_profile_id,
    prepare_marketplace_buy_now_checkout,
    get_marketplace_display_description
} from "@/views/Marketplace/marketplace_helpers";
import {
    auto_select_single_product_attribute_options,
    format_product_attribute_text,
    get_product_min_date,
    get_product_rating_level,
    handle_product_review_submission_success,
    has_submitted_existing_product_review,
    open_edit_product_review_state,
    cancel_edit_product_review_state,
    review_belongs_to_current_user,
    submit_product_review_request
} from "@/views/ProductView/product_view_helpers";

export default {
    name: "ProductView",
    components: {
        HomeNavBar,
    },
    inject: ['client_features'],
    data() {
        return ({
            loading: true,
            loading_recommendations: false,
            product: null,
            recommendations: [],
            selected_attributes: {},
            attribute_errors: {},
            selected_quantity: 1,
            adding_to_cart: false,
            buying_now: false,
            page_error: "",
            product_id: this.$route.params.slug,
            service_request: {
                message: '',
                email: '',
                contact_number: '',
                date: '',
                product_id: null
            },
            service_availability_week_offset: 0,
            selected_service_request_day_key: '',
            selected_service_availability_month: '',
            selected_service: null,
            show_service_view: false,
            active_image_index: 0,
            gallery_touch_start_x: 0,
            gallery_touch_start_y: 0,
            gallery_pointer_start_x: 0,
            gallery_pointer_start_y: 0,
            gallery_pointer_active: false,
            isLoading: false,
            errors: {
                service_date: "",
                email: "",
                contact_number: "",
                location: ""
            },
            user_details: get_user_details() || {},
            product_reviews: [],
            new_rating: 0,
            hover_rating: 0,
            product_review_text: "",
            show_product_reviews: false,
            is_editing_product_review: false,
            editing_product_review_id: null,

        });
    },
    mounted() {
        this.user_details = get_user_details() || {};
    },
    computed: {
        product_images() {
            return this.product?.images?.length
                ? this.product.images
                : [{ image_url: "https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/image_placeholder.webp" }];
        },
        product_type_label() {
            return this.product?.product_type?.name || "Product";
        },
        required_attribute_groups() {
            return this.get_required_attribute_groups(this.product?.attributes || []);
        },
        selected_image() {
            return this.product_images[this.active_image_index] || this.product_images[0];
        },
        min_date() {
            return get_product_min_date();
        },
        rating_level() {
            return get_product_rating_level(this.hover_rating, this.new_rating);
        },
        has_submitted_product_review() {
            return Boolean(this.product?.user_has_rated_product) ||
                (this.product_reviews || []).some((review) => this.review_belongs_to_current_user(review));
        },
        is_quantity_disabled() {
            return this.is_my_product(this.product);
        },
        service_availability_days() {
            return build_service_availability_days(
                this.service_availability_week_offset,
                5,
                this.selected_service_availability_month
            );
        },
        service_availability_month_label() {
            return get_service_availability_month_label(this.service_availability_days);
        },
        service_availability_times() {
            return get_service_availability_times();
        },
        min_service_availability_month() {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        },
        selected_service_request_day() {
            return this.service_availability_days.find(
                (day) => day.date_key === this.selected_service_request_day_key
            ) || this.service_availability_days[0];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.load_page();
            }
        }
    },
    methods: {
        async load_page() {
            this.loading = true;
            this.page_error = "";
            this.product = null;
            this.recommendations = [];
            this.reset_selection_state();
            this.user_details = get_user_details() || {};

            try {
                const slug = this.$route.params.slug;
                const product_id = slug.split('-').pop();

                if (!product_id) {
                    this.page_error = "Missing product id";
                    return;
                }
                const product = await this.fetch_product_by_id(product_id);
                if (!product) {
                    this.page_error = "We couldn't find that product.";
                    return;
                }

                this.product = product;
                console.log("[ReviewDebug] product view loaded product", {
                    product_id: product?.id,
                    product_name: product?.name,
                    can_review: product?.can_review,
                    review_count: product?.reviews?.length || 0,
                });
                this.selected_attributes = auto_select_single_product_attribute_options(
                    this.get_required_attribute_groups(product?.attributes || []),
                    this.selected_attributes
                );
                this.product_reviews = product?.reviews || [];
                this.product.user_has_rated_product = has_submitted_existing_product_review(
                    product,
                    this.product_reviews,
                    this.user_details
                );
                this.new_rating = 0;
                this.hover_rating = 0;
                this.product_review_text = "";
                this.show_product_reviews = false;
                this.is_editing_product_review = false;
                this.editing_product_review_id = null;
                if (product.product_type?.name?.toLowerCase() === "service") {
                    this.open_service(product);   // sets service view
                }
                await this.load_recommendations();
            } catch (error) {
                console.error("Failed to load product view:", error);
                this.page_error = "We couldn't load this product right now.";
            } finally {
                this.loading = false;
            }
        },

        async fetch_product_by_id(product_id) {
            return new Promise((resolve, reject) => {
                const token = get_token();
                console.log("[ReviewDebug] fetching product", {
                    product_id,
                    token_present: Boolean(token),
                });
                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_product/`,
                    type: "POST",
                    headers: token ? { Authorization: `Token ${token}` } : {},
                    data: JSON.stringify({
                        product_id: product_id, user_id: this.user_details?.user_id || null
                    }),

                    contentType: "application/json",
                    processData: false,
                    success: function (response) {
                        console.log("[ReviewDebug] get_product response", {
                            product_id: response?.data?.id,
                            can_review: response?.data?.can_review,
                            user_has_rated_product: response?.data?.user_has_rated_product,
                        });
                        resolve(response.data);
                    },

                    error: function (xhr) {
                        console.warn("[ReviewDebug] get_product failed", {
                            status: xhr?.status,
                            response: xhr?.responseJSON || xhr?.responseText,
                        });
                        console.error(xhr.responseText);
                        reject(xhr);
                    }
                });
            });
        },

        async load_recommendations_legacy() {
            this.loading_recommendations = true;

            try {
                const response = await axios.get(this.get_legacy_recommendations_endpoint(), {
                    params: {
                        page: 1,
                        page_size: 100
                    }
                });

                const items = this.get_legacy_recommendation_items(response);
                this.shuffle_recommendation_items(items);
                this.recommendations = items.slice(0, 4);
            } catch (error) {
                console.error("Failed to load recommendations:", error);
                this.recommendations = [];
            } finally {
                this.loading_recommendations = false;
            }
        },
        get_legacy_recommendations_endpoint() {
            const base = process.env.VUE_APP_BACKEND_API_URL;
            const type = this.product.product_type.name;

            return type === "product"
                ? `${base}/ads_management/get_marketplace_products/`
                : `${base}/ads_management/get_marketplace_services/`;
        },
        get_legacy_recommendation_items(response) {
            const current_id = this.product?.id || this.service?.id;
            const items = response?.data?.data || [];

            return items.filter((item) => String(item?.id) !== String(current_id));
        },
        shuffle_recommendation_items(items) {
            for (let i = Reflect.get(items, "length") - 1; i > 0; i--) {
                this.swap_recommendation_items(items, i, Math.floor(Math.random() * (i + 1)));
            }
        },
        swap_recommendation_items(items, first_index, second_index) {
            const first_item = Reflect.get(items, first_index);
            const second_item = Reflect.get(items, second_index);

            Reflect.set(items, first_index, second_item);
            Reflect.set(items, second_index, first_item);
        },
    async load_recommendations() {
    const product_id = this.product?.id;

    if (!product_id) return;

    this.loading_recommendations = true;

    try {
        const token = get_token();

        const response = await axios.get(
            `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_product_recommendations/`,
            {
                params: this.build_recommendation_params(product_id),
                headers: token ? { Authorization: `Token ${token}` } : {},
            }
        );

        this.recommendations = this.get_recommendation_items(response)
            .filter((item) => String(item?.id) !== String(product_id))
            .slice(0, 4);
    } catch (error) {
        console.error("Failed to load recommendations:", error);
        this.recommendations = [];
    } finally {
        this.loading_recommendations = false;
    }
},
        build_recommendation_params(product_id) {
            const organization_id = this.get_recommendation_organization_id();
            return ({
                product_id,
                ...(organization_id ? { organization_id } : {}),
            });
        },
        get_recommendation_organization_id() {
            if (!is_enabled_feature(this.client_features?.show_organisation)) return '';
            return this.user_details?.organization_id || get_active_organization_id() || '';
        },
        get_recommendation_items(response) {
            const payload = response?.data;
            if (Array.isArray(payload?.data)) return payload.data;

            return [];
        },
        prev_image() {
            if (!this.product_images.length) return;

            this.active_image_index =
                (this.active_image_index - 1 + this.product_images.length) %
                this.product_images.length;
        },

        next_image() {
            if (!this.product_images.length) return;

            this.active_image_index =
                (this.active_image_index + 1) %
                this.product_images.length;
        },

        handle_gallery_touch_start(event) {
            const touch = event.touches?.[0];
            if (!touch || this.product_images.length <= 1) return;

            this.gallery_touch_start_x = touch.clientX;
            this.gallery_touch_start_y = touch.clientY;
        },

        handle_gallery_touch_end(event) {
            const touch = event.changedTouches?.[0];
            if (!touch || this.product_images.length <= 1) return;

            this.handle_gallery_swipe(
                touch.clientX - this.gallery_touch_start_x,
                touch.clientY - this.gallery_touch_start_y
            );
        },

        handle_gallery_pointer_start(event) {
            if (this.product_images.length <= 1) return;

            this.gallery_pointer_active = true;
            this.gallery_pointer_start_x = event.clientX;
            this.gallery_pointer_start_y = event.clientY;
        },

        handle_gallery_pointer_end(event) {
            if (!this.gallery_pointer_active || this.product_images.length <= 1) return;

            this.handle_gallery_swipe(
                event.clientX - this.gallery_pointer_start_x,
                event.clientY - this.gallery_pointer_start_y
            );
            this.clear_gallery_pointer();
        },

        clear_gallery_pointer() {
            this.gallery_pointer_active = false;
        },

        handle_gallery_swipe(delta_x, delta_y) {
            const minimum_swipe_distance = 45;

            if (Math.abs(delta_x) < minimum_swipe_distance || Math.abs(delta_x) <= Math.abs(delta_y)) {
                return;
            }

            if (delta_x < 0) {
                this.next_image();
            } else {
                this.prev_image();
            }
        },

        go_back() {
            this.$router.back();
        },

        get_company_name(product) {
            return get_marketplace_company_name(product);
        },

        display_price(product) {
            return display_marketplace_price(product);
        },
        get_display_description(value) {
            return get_marketplace_display_description(value);
        },
        should_show_product_sale(product) {
            return has_active_marketplace_product_sale(product);
        },
        get_product_original_price(product) {
            return get_marketplace_original_price(product);
        },
        get_product_sale_price(product) {
            return get_marketplace_sale_price(product);
        },
        get_product_sale_discount_label(product) {
            return get_marketplace_sale_discount_label(product);
        },
        format_price(price) {
            return format_marketplace_price(price);
        },
        format_attribute_text(value) {
            return format_product_attribute_text(value);
        },
        toggle_product_reviews() {
            this.show_product_reviews = !this.show_product_reviews;
        },
        review_belongs_to_current_user(review = {}) {
            return review_belongs_to_current_user(review, this.user_details);
        },
        has_submitted_existing_review(product = {}, reviews = []) {
            return has_submitted_existing_product_review(product, reviews, this.user_details);
        },
        open_edit_product_review(review = {}) {
            Object.assign(this, open_edit_product_review_state(review));
        },
        cancel_edit_product_review() {
            Object.assign(this, cancel_edit_product_review_state());
        },
        submit_product_review() {
            if (!this.product?.id || !this.new_rating || !this.product_review_text.trim()) {
                console.warn("[ReviewDebug] product view submit blocked on frontend validation", {
                    product_id: this.product?.id,
                    can_review: this.product?.can_review,
                    rating: this.new_rating,
                    has_review_text: Boolean(this.product_review_text.trim()),
                });
                return;
            }
            console.log("[ReviewDebug] submitting review from product view", {
                product_id: this.product.id,
                can_review: this.product?.can_review,
                rating: this.new_rating,
            });
            submit_product_review_request({
                product_id: this.product.id,
                rating: this.new_rating,
                review: this.product_review_text,
                on_success: (response) => {
                    const nextState = handle_product_review_submission_success({
                        response,
                        product: this.product,
                        product_reviews: this.product_reviews,
                        editing_product_review_id: this.editing_product_review_id,
                        user_details: this.user_details,
                        is_editing_product_review: this.is_editing_product_review,
                    });

                    this.product_reviews = nextState.product_reviews;
                    Object.assign(this, {
                        new_rating: nextState.new_rating,
                        hover_rating: nextState.hover_rating,
                        product_review_text: nextState.product_review_text,
                        is_editing_product_review: nextState.is_editing_product_review,
                        editing_product_review_id: nextState.editing_product_review_id,
                    });
                },
            });
        },
        format_date(datestr) {
            if (!datestr) return "";

            return new Date(datestr).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
            });
        },

        group_attributes(attributes) {
            return group_marketplace_attributes(attributes);
        },

        get_required_attribute_groups(attributes = []) {
            return get_required_marketplace_attribute_groups(attributes);
        },

        select_attribute(type, attr) {
            const next_state = select_marketplace_attribute({
                selected_attributes: this.selected_attributes,
                attribute_errors: this.attribute_errors,
                type,
                attribute: attr
            });

            this.selected_attributes = next_state.selected_attributes;
            this.attribute_errors = next_state.attribute_errors;
        },

        validate_required_attributes() {
            const validation = validate_marketplace_required_attributes(
                this.get_required_attribute_groups(this.product?.attributes || []),
                this.selected_attributes
            );
            this.attribute_errors = validation.attribute_errors;

            return validation.valid;
        },

        get_product_base_profile_id(product = this.product) {
            return get_marketplace_product_base_profile_id(product);
        },

        get_current_product_owner_ids() {
            return [
                this.user_details?.base_profile_id,
                this.user_details?.base_profile?.id,
                this.user_details?.active_base_profile_id,
                this.user_details?.profile_id,
                localStorage.getItem("active_profile_id"),
                localStorage.getItem("active_base_profile_id"),
                localStorage.getItem("base_profile_id"),
            ]
                .filter((id) => id !== undefined && id !== null && String(id).trim() !== "")
                .map((id) => String(id));
        },

        get_product_owner_ids(product = {}) {
            return [
                product?.base_profile?.company?.base_profile?.id,
                product?.base_profile?.id,
                product?.base_profile_id,
            ]
                .filter((id) => id !== undefined && id !== null && String(id).trim() !== "")
                .map((id) => String(id));
        },

        is_my_product(product = this.product) {
            const current_user_id = String(this.user_details?.user_id || this.user_details?.id || "");
            const product_user_id = String(product?.user?.id || product?.base_profile?.user?.id || "");
            const owner_ids = new Set(this.get_current_product_owner_ids());

            return Boolean(
                (current_user_id && product_user_id && current_user_id === product_user_id)
                || this.get_product_owner_ids(product).some((id) => owner_ids.has(id))
            );
        },

        async add_current_product_to_cart() {
            if (!this.product || this.adding_to_cart || this.buying_now) return;
            if (this.is_my_product(this.product)) return;
            if (!this.validate_required_attributes()) return;

            const token = get_token();
            if (!token) {
                window.location = "/register";
                return;
            }

            const base_profile_id = this.get_product_base_profile_id();
            if (!base_profile_id) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Unable to identify product vendor",
                    timer: 1800,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                });
                return;
            }
            this.adding_to_cart = true;
            try {
                const response = await add_to_cart_helper({
                    product_id: this.product.id,
                    base_profile_id,
                    token,
                    quantity: this.selected_quantity,
                    attributes: Object.values(this.selected_attributes || {})
                });

                if (response?.status !== "success") {
                    throw new Error(response?.message || "Failed to add product to cart");}
                Swal.fire({
                    icon: "success",
                    title: response.message || "Added to cart",
                    timer: 1500,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                });
            } catch (error) {
                console.error("Error adding product to cart:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error?.responseJSON?.message || error?.message || "Failed to add product to cart",
                    timer: 1800,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                });
            } finally {
                this.adding_to_cart = false;
            }
        },

        async buy_now() {
            if (!this.product || this.adding_to_cart || this.buying_now) return;
            if (this.is_my_product(this.product)) return;
            if (!this.validate_required_attributes()) return;

            const token = get_token();
            if (!token) {
                window.location = "/register";
                return;
            }

            this.buying_now = true;
            const attributes = Object.values(this.selected_attributes || {});

            try {
                const checkout = await prepare_marketplace_buy_now_checkout({
                    product: this.product,
                    token,
                    quantity: this.selected_quantity,
                    attributes
                });

                this.$router.push({
                    name: "cart_checkout",
                    params: { checkout_slug: checkout.checkout_slug }
                });
            } catch (error) {
                console.error("Error preparing checkout:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error?.responseJSON?.message || error?.message || "Failed to proceed to checkout",
                    timer: 1800,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                });
            } finally {
                this.buying_now = false;
            }
        },

        view_recommended_product(product) {
            view_profile_product(this.$router, product);
        },

        increase_quantity() {
            if (this.is_quantity_disabled) return;

            this.selected_quantity += 1;
        },

        decrease_quantity() {
            if (this.is_quantity_disabled) return;

            if (this.selected_quantity > 1) {
                this.selected_quantity -= 1;}
        },

        set_active_image(index) {
            this.active_image_index = index;
        },

        reset_selection_state() {
            this.selected_attributes = {};
            this.attribute_errors = {};
            this.selected_quantity = 1;
            this.active_image_index = 0;
        },

        view_profile(profile) {
            const base_profile = profile?.company?.base_profile || profile;
            go_to_profile(this.$router, base_profile);
        },
        auto_complete_map() {
            const inputElement = this.$refs.marketplaceLocationInput;

            auto_complete_map_helper(inputElement, (address) => {
                this.service_request.location = address;
            }).catch((error) => {
                console.error('Failed to load Google address suggestions:', error);
            });
        },

        open_service(service) {
            const contact_details = get_service_request_prefill(this.user_details);

            this.product = service;
            this.active_image_index = 0;
            this.errors = {};
            this.service_request = {
                ...service,
                service_id: service.id,
                email: contact_details.email,
                contact_number: contact_details.contact_number,
                message: '',
                location: '',
                date: ''
            };
            this.service_availability_week_offset = 0;
            this.selected_service_availability_month = this.min_service_availability_month;
            this.selected_service_request_day_key = this.service_availability_days[0]?.date_key || '';
            this.show_service_view = true;

            this.$nextTick(() => {
                if (service?.service_details?.type_name === 'on_site') {
                    this.auto_complete_map();
                }
            });
        },
        sync_service_request_field(field_name = "") {
            if (field_name === "contact_number") {
                this.service_request.contact_number = sanitize_service_request_phone_number(
                    this.service_request?.contact_number
                );
            }

            if (field_name === "date") {
                this.service_request.date = normalize_service_request_date(
                    this.service_request?.date,
                    this.min_date
                );
            }

            if (field_name === "email" && this.errors?.email) {
                this.errors = { ...this.errors, email: "" };
            }

            if (field_name === "contact_number" && this.errors?.contact_number) {
                this.errors = { ...this.errors, contact_number: "" };
            }

            if (field_name === "location" && this.errors?.location) {
                this.errors = { ...this.errors, location: "" };
            }

            if (field_name === "date" && this.errors?.service_date) {
                this.errors = { ...this.errors, service_date: "" };
            }
        },

        select_service_request_slot(day, time) {
            if (this.is_service_request_slot_disabled(day, time)) return;

            this.selected_service_request_day_key = day.date_key;
            this.service_request.date = build_service_request_datetime(day, time);
            this.sync_service_request_field("date");
        },
        select_service_request_day(day) {
            const was_selected_day = this.is_service_request_day_selected(day);
            this.selected_service_request_day_key = day.date_key;

            if (this.service_request?.date && !was_selected_day) {
                this.service_request.date = "";
            }
        },
        change_service_availability_week(direction) {
            const next_offset = this.service_availability_week_offset + direction;
            this.service_availability_week_offset = Math.max(0, next_offset);
            this.selected_service_request_day_key = this.service_availability_days[0]?.date_key || "";
        },
        select_service_availability_month(event) {
            const month_value = event?.target?.value || "";
            if (!month_value) return;

            this.selected_service_availability_month = month_value;
            this.service_availability_week_offset = 0;
            this.selected_service_request_day_key = this.service_availability_days[0]?.date_key || "";
            this.service_request.date = "";
        },
        is_service_request_day_selected(day) {
            return this.selected_service_request_day?.date_key === day.date_key;
        },
        is_service_request_slot_selected(day, time) {
            return this.service_request?.date === build_service_request_datetime(day, time);
        },
        is_service_request_slot_disabled(day, time) {
            return is_service_request_slot_disabled(day, time, this.min_date);
        },
        format_service_slot_label(time) {
            return format_service_slot_label(time);
        },

        submit_service_request() {
            if (this.is_my_product(this.product)) return;
            this.sync_service_request_field("contact_number");
            this.sync_service_request_field("date");
            submit_service_request_flow({
                service_request: this.service_request,
                product_id: this.product.id,
                set_loading: (val) => {
                    this.isLoading = val;
                },
                set_errors: (errors) => {
                    this.errors = errors;
                },
                on_success: () => {
                    this.service_request = reset_service_request_state();
                    this.$router.push({
                        name: "my_orders",
                        query: {
                            tab: "services"
                        }
                    });
                }
            });
        }
    }
}


